import { PriceRecurringInterval } from 'dy-frontend-http-repository/lib/data/enums';

const priceRecurringIntervalToNumberValues: { [key in PriceRecurringInterval]: number } = {
    [PriceRecurringInterval.YEAR]: 365,
    [PriceRecurringInterval.MONTH]: 30,
    [PriceRecurringInterval.WEEK]: 7,
    [PriceRecurringInterval.DAY]: 1,
};

export default priceRecurringIntervalToNumberValues;
